// extracted by mini-css-extract-plugin
export default {"title":"_5a3f5f9b6e","bld":"ac401471bf"};